export default "__VITE_ASSET__D92LV83C__"